import { render, staticRenderFns } from "./top.vue?vue&type=template&id=2fd74fba&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=2fd74fba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd74fba",
  null
  
)

export default component.exports